import { Calendar, UserLock, ShieldAlert, Clock } from "lucide-react";
import { cn } from "@/lib/utils";
import { PermissaoEnum } from "@workflow/types";
import { PermissionWrapper } from "@/components/permissao/PermissionWrapper";

interface ProfileFooterProps {
  membroDesde: string;
  ultimoAcessoLabel: string;
  isLastLoginOverdue: boolean;
  isExColaborador: boolean;
  isAusente: boolean;
}

export function ProfileFooter({
  membroDesde,
  ultimoAcessoLabel,
  isLastLoginOverdue,
  isExColaborador,
  isAusente,
}: ProfileFooterProps) {
  return (
    <div className="mt-6 space-y-3 border-t border-border/50 pt-5">
      <div className="flex items-center gap-2 text-[11px] font-bold uppercase tracking-wider text-muted-foreground/80">
        <Calendar className="h-3.5 w-3.5" />
        <span>Usuário desde {membroDesde}</span>
      </div>

      <PermissionWrapper permission={PermissaoEnum.ADMIN}>
        <div className="flex items-center gap-2 text-[11px] font-bold uppercase tracking-wider text-muted-foreground/80">
          <UserLock className="h-3.5 w-3.5" />
          <span className={cn("flex items-center gap-1", isLastLoginOverdue && "text-destructive")}>
            {ultimoAcessoLabel}
          </span>
        </div>
      </PermissionWrapper>

      {isExColaborador && (
        <div className="flex items-start gap-2.5 rounded-lg border border-destructive/20 bg-destructive/10 p-3">
          <ShieldAlert className="mt-0.5 h-4 w-4 shrink-0 text-destructive" />
          <p className="text-xs font-medium leading-relaxed text-destructive">
            Este usuário foi inativado e não possui mais acesso às ferramentas da empresa.
          </p>
        </div>
      )}

      {isAusente && !isExColaborador && (
        <div className="flex items-start gap-2.5 rounded-lg border border-amber-500/20 bg-amber-500/10 p-3 dark:border-amber-900/50 dark:bg-amber-950/30">
          <Clock className="mt-0.5 h-4 w-4 shrink-0 text-amber-600 dark:text-amber-500" />
          <p className="text-xs font-medium leading-relaxed text-amber-700 dark:text-amber-400">
            Este usuário está marcado como ausente (férias/licença) e pode demorar a responder.
          </p>
        </div>
      )}
    </div>
  );
}
